import { render } from "./form-part-b-overview.html?vue&type=template&id=cb77fac0&scoped=true&ts=true&external"
import script from "./form-part-b-overview.ts?vue&type=script&lang=ts&external"
export * from "./form-part-b-overview.ts?vue&type=script&lang=ts&external"

import "./form-part-b-overview.scss?vue&type=style&index=0&id=cb77fac0&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb77fac0"]])

export default __exports__